import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"background-color":"#f5f5f5","overflow":"hidden","margin-top":"0.7rem"} }
const _hoisted_2 = { class: "uploadDataBox" }
const _hoisted_3 = { class: "invoice_information" }
const _hoisted_4 = { class: "uploadDataBox" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "uploadDataBox" }
const _hoisted_8 = {
  key: 0,
  style: {"width":"80%","margin":"0 auto"}
}

import { UploadFilled } from "@element-plus/icons-vue";
import { reactive, ref } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import { Axios } from "@/assets/js/ls_com_axios.js";
import { useRoute, useRouter } from "vue-router";
import { ElTable, ElMessage } from "element-plus";

interface RuleForm {
  type: number;
  price: number;
}
const percentageValue = 30;

export default /*@__PURE__*/_defineComponent({
  __name: 'invoice_debit',
  setup(__props) {

const formSize = ref("default");
const ruleFormRef = ref<FormInstance>();
const progressValue = (percentage) =>
  percentage === 100 ? "100%" : `${percentage}%`;
// do not use same name with ref
const ruleForm = reactive<any>({
  type: 1,
  price: "",
});
const rules = reactive<FormRules<RuleForm>>({
  type: [
    {
      required: true,
      message: "请选择内容",
      trigger: "blur",
    },
  ],
  radio: [
    {
      required: true,
      message: "请输入内容",
      trigger: "blur",
    },
  ],
  header: [
    {
      required: true,
      message: "请输入内容",
      trigger: "blur",
    },
  ],
  dutyParagraph1: [
    {
      required: true,
      message: "请输入内容",
      trigger: "blur",
    },
  ],
  email: [
    {
      required: true,
      message: "请输入内容",
      trigger: "blur",
    },
  ],
});

//订单详情
const router = useRouter();
const route = useRoute();
const id = route.query.arry;
const orderDetail = ref({});
const debitType = ref(route.query.type);
const debitType1 = ref(route.query.type1);
const price = ref(route.query.price);
const init = () => {
  if (debitType.value == "add" && !debitType1.value) {
    Axios("get", "/fodder/order/info/" + id, false, false, (res) => {
      let data = res.data.data;
      ruleForm.orderId = data[0].id;
      for (var k in data[0]) {
        ruleForm[k] = data[0][k];
      }
    });
  } else if (debitType1.value) {
    ruleForm.price = price;
    ruleForm.sellerName = "标识山西影像资源共享平台";
    // Axios("get", "/fodder/order/info/" + id, false, false, (res) => {
    //   //   let data = res.data.data;
    //   //   ruleForm.orderId = data[0].id;
    // });
  } else {
    Axios("get", "/fodder/invoice/" + id, false, false, (res) => {
      let data = res.data.data;
      data.dutyParagraph1 = data.dutyParagraph;
      data.dutyParagraph2 = data.dutyParagraph;

      for (var k in data) {
        ruleForm[k] = data[k];
      }
    });
  }
};
init();
//保存发票
const onSubmit = () => {
  if (!ruleForm.type) {
    ElMessage({
      message: "请选择发票类型",
      type: "warning",
    });
    return;
  }

  if (ruleForm.type == 1) {
    if (!ruleForm.header) {
      ElMessage({
        message: "请输入发票抬头",
        type: "warning",
      });
      return;
    }

    if (!ruleForm.dutyParagraph1) {
      ElMessage({
        message: "请输入企业税收",
        type: "warning",
      });
      return;
    }
  }
  if (ruleForm.type == 2) {
    if (!ruleForm.header) {
      ElMessage({
        message: "请输入需要开具发票的姓名",
        type: "warning",
      });
      return;
    }
    if (!ruleForm.phone) {
      ElMessage({
        message: "请输入手机号",
        type: "warning",
      });
      return;
    }
  }
  if (ruleForm.type == 3) {
    if (!ruleForm.header) {
      ElMessage({
        message: "请输入发票抬头",
        type: "warning",
      });
      return;
    }
  }
  if (!ruleForm.email) {
    ElMessage({
      message: "请输入电子邮箱",
      type: "warning",
    });
    return;
  }

  ruleForm.dutyParagraph =
    ruleForm.type == 1
      ? ruleForm.dutyParagraph1
      : ruleForm.type == 3
        ? ruleForm.dutyParagraph2
        : "";
  ruleForm.price = orderDetail.value.price;
  ruleForm.createTime = '';
  ruleForm.payTime = '';
  if (debitType1.value) {

    let obj = JSON.parse(JSON.stringify(ruleForm));
    let obj1 = route.query;
    obj.sellerName = "山西星卫视传媒有限公司";
    obj.businessId = obj1.arry;
    obj.businessType = 1;
    obj.orderNo = obj1.needNo;
    obj.price = obj1.price;
    Axios("post", "/material/material/invoice/sou", obj, false, function (res) {
      console.log(res);
      ElMessage({
        message: "提交成功",
        type: "success",
      });
      setTimeout(() => {
        router.push({
          path: "/myDebit",
        });
      }, 1000);
    });
  } else {
    ruleForm.sellerName = "山西星卫视传媒有限公司";
    Axios(
      debitType.value == "add" ? "post" : "put",
      "/fodder/invoice",
      ruleForm,
      false,
      function (res) {
        console.log(res);
        ElMessage({
          message: "提交成功",
          type: "success",
        });
        setTimeout(() => {
          router.push({
            path: "/myDebit",
          });
        }, 1000);
      }
    );
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { style: {"font-size":"16px","color":"#333333","margin-bottom":"12px"} }, " 发票信息 ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("div", null, [
          _createElementVNode("div", null, "发票内容："),
          _createElementVNode("div", null, "信息技术服务费")
        ], -1)),
        _cache[13] || (_cache[13] = _createElementVNode("div", null, [
          _createElementVNode("div", null, "开票方："),
          _createElementVNode("div", null, "山西星卫视传媒有限公司")
        ], -1)),
        _createElementVNode("div", null, [
          _cache[11] || (_cache[11] = _createElementVNode("div", null, "开票金额：", -1)),
          _createElementVNode("div", null, _toDisplayString(ruleForm.price) + "元", 1)
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("div", null, [
          _createElementVNode("div", null, "发票类型："),
          _createElementVNode("div", null, "增值税电子普通发票")
        ], -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[19] || (_cache[19] = _createElementVNode("div", { style: {"font-size":"16px","color":"#333333","margin-bottom":"12px"} }, " 请填写发票抬头 ", -1)),
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: ruleForm,
        "label-width": "100px",
        rules: rules,
        class: "demo-ruleForm",
        size: formSize.value,
        "status-icon": "",
        "label-position": "left"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "发票类型",
            prop: "type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                disabled: debitType.value == 'view',
                modelValue: ruleForm.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.type) = $event)),
                class: "ml-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: 1,
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("企业")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: 2,
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createTextVNode("个人")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: 3,
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode("非企业单位（政府机关、事业单位、军队、学校等非营利性组织）")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled", "modelValue"])
            ]),
            _: 1
          }),
          (ruleForm.type == 1 || ruleForm.type == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_el_form_item, {
                  label: "发票抬头",
                  prop: "header"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      disabled: debitType.value == 'view',
                      modelValue: ruleForm.header,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.header) = $event)),
                      placeholder: "请输入发票抬头"
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                }),
                (ruleForm.type == 1)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "企业税号",
                      prop: "dutyParagraph1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: debitType.value == 'view',
                          modelValue: ruleForm.dutyParagraph1,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.dutyParagraph1) = $event)),
                          placeholder: "请输入企业税号"
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (ruleForm.type == 3)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "企业税号",
                      prop: "dutyParagraph2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: debitType.value == 'view',
                          modelValue: ruleForm.dutyParagraph2,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.dutyParagraph2) = $event)),
                          placeholder: "请输入企业税号"
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: "注册地址",
                  prop: "address"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      disabled: debitType.value == 'view',
                      modelValue: ruleForm.address,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.address) = $event)),
                      placeholder: "请输入注册地址"
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "注册电话",
                  prop: "phone"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      disabled: debitType.value == 'view',
                      modelValue: ruleForm.phone,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.phone) = $event)),
                      placeholder: "请输入注册电话"
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "开户银行",
                  prop: "openBank"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      disabled: debitType.value == 'view',
                      modelValue: ruleForm.openBank,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ruleForm.openBank) = $event)),
                      placeholder: "请输入开户银行"
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "银行账号",
                  prop: "bankAccount"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      disabled: debitType.value == 'view',
                      modelValue: ruleForm.bankAccount,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ruleForm.bankAccount) = $event)),
                      placeholder: "请输入银行账号"
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (ruleForm.type == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_el_form_item, {
                  label: "发票抬头",
                  prop: "header"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      disabled: debitType.value == 'view',
                      modelValue: ruleForm.header,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((ruleForm.header) = $event)),
                      placeholder: "请输入需要开具发票的姓名"
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "手机号",
                  prop: "phone",
                  rules: [{ required: true, message: '请输入手机号', trigger: 'blur' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      disabled: debitType.value == 'view',
                      modelValue: ruleForm.phone,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ruleForm.phone) = $event)),
                      placeholder: "请输入手机号"
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules", "size"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[20] || (_cache[20] = _createElementVNode("div", { style: {"font-size":"16px","color":"#333333","margin-bottom":"12px"} }, " 请填写电子邮箱 ", -1)),
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: ruleForm,
        "label-width": "100px",
        rules: rules,
        class: "demo-ruleForm",
        size: formSize.value,
        "status-icon": "",
        "label-position": "left"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "电子邮箱",
            prop: "email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: ruleForm.email,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((ruleForm.email) = $event)),
                disabled: debitType.value == 'view',
                placeholder: "请输入电子邮箱"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "size"])
    ]),
    (debitType.value == 'add')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "dataBtn",
            onClick: onSubmit
          }, "提交")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})